import CssBaseLine from '@material-ui/core/CssBaseline';
import {
	StylesProvider,
	ThemeProvider,
	createTheme,
	jssPreset,
	responsiveFontSizes,
} from '@material-ui/core/styles';
// import useWhiteLabelProject from 'Hook/useEntkhabino';
import { create } from 'jss';
import rtl from 'jss-rtl';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
let theme = createTheme({
	palette: {
		primary: {
			main: '#0184FD',
		},
		secondary: {
			main: '#EE3863',
		},
	},
	typography: {
		fontFamily: ['yekan-bakh'].join(', '),
	},
	direction: 'rtl',
	overrides: {
		MuiCssBaseline: {
			'@global': {
				body: {
					padding: '0',
					margin: '0',
					boxSizing: 'border-box',
				},
				'*': {
					margin: 0,
					padding: 0,
					boxSizing: 'border-box',
				},
				ul: {
					listStyle: 'none',
				},
				li: {
					listStyle: 'none',
				},
				a: {
					textDecoration: 'none',
				},
			},
		},
		MuiSlider: {
			thumb: {
				color: '',
			},
			track: {
				color: '',
			},
			rail: {
				color: '',
			},
		},
		MuiPaper: {
			styleOverrides: {
				elevation1: {
					boxShadow: ' 0px 40px 50px rgba(34, 36, 45, 0.06)',
				},
				elevation3: {
					boxShadow: '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14)',
				},
				outlined: {
					backgroundColor: 'transparent',
				},
				root: {
					// backgroundColor: setColor('background'),
				},
				rounded: {
					borderRadius: 5,
				},
			},
		},
	},
});

export default function RTL({ children }) {
	theme = responsiveFontSizes(theme);

	return (
		<StylesProvider jss={jss}>
			<CssBaseLine />
			<ThemeProvider theme={theme}>{children}</ThemeProvider>
		</StylesProvider>
	);
}
